import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import { Card, CardContent, Typography, Box, Grid, Button, Alert } from "@deere/fuel-react";
import { getCountry, getBoundary } from "../../services/external.service";
import { getSubtierSupplierData } from "../../services/survey.service";
import { setSTSupplierData, addCountries, addStates, deleteSTSupplierData, addSTSupplierData } from "../../redux/action/subTierSurveyAction";
import SupplierDataCard from "./SupplierDataCard";
import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add.svg";
import { ModalGeneric } from "../../components/ModalGeneric";
import { useLocation } from "react-router-dom";

const SupplierData = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { authState } = useOktaAuth();
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteSupplierModal, setShowDeleteSupplierModal] = useState(false);
  const [supplierIdToBeDeleted, setSupplierIdToBeDeleted] = useState("");
  const [deleteSupplierName, setDeleteSupplierName] = useState("");
  const [scroll, setScroll] = useState(0);
  const scrollRef = useRef(null);

  let previousPage = location ? (location.state ? (location.state.previous ? location.state.previous : "") : "") : "";

  const arrCountriesRx = useSelector((state) => state.subTierSurvey.countries);
  const arrStatesRx = useSelector((state) => state.subTierSurvey.states);
  const arrTableDataTemp = useSelector((state) => state.subTierSurvey.supplierData);
  const arrTableData = [];
  arrTableDataTemp.forEach((d) => {
    if (!d.deletedByUser) arrTableData.push(d);
  });
  let isAuthMethodOkta = props.isAuthMethodOkta || props.isAuthMethodOkta === undefined ? true : false;
  let token = props.isAuthMethodOkta || props.isAuthMethodOkta ? authState.accessToken.accessToken : "";

  useEffect(() => {
    if (arrTableData.length === 0 || previousPage == "/details") {
      getSubtierSupplierData(props.supplierId, token, isAuthMethodOkta).then((resSuppData) => {
        if (resSuppData) {
          dispatch(setSTSupplierData([...resSuppData]));
          const statesToFetchFor = [];
          getCountry(token, isAuthMethodOkta)
            .then((res) => {
              if (res.length !== 0) {
                res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
                dispatch(addCountries(res));
                let temp = [];
                res.forEach((item) => temp.push({ value: item.name, label: item.name, code: item.iso2CountryCode }));
                setCountries(temp);
                if (resSuppData.length > 0) {
                  resSuppData.forEach((data) => {
                    if (data.country !== "") {
                      let country = res.find((item) => item.name === data.country);
                      if (country && !statesToFetchFor.includes(country.iso2CountryCode)) statesToFetchFor.push(country.iso2CountryCode);
                    }
                  });
                  if (statesToFetchFor.length > 0) getStates(statesToFetchFor);
                  else setLoading(false);
                } else setLoading(false);
              } else setLoading(false);
            })
            .catch((err) => console.log(err));
        }
      });
    } else {
      let temp = [];
      arrCountriesRx.forEach((item) => temp.push({ value: item.name, label: item.name, code: item.iso2CountryCode }));
      setCountries(temp);
    }
  }, []);

  useEffect(() => {
    if (arrStatesRx.length > 0) {
      const statesToFetchFor = [];
      arrTableData.forEach((data) => {
        if (data.country !== "") {
          let country = arrCountriesRx.find((item) => item.name === data.country);
          if (country && !statesToFetchFor.includes(country.iso2CountryCode)) statesToFetchFor.push(country.iso2CountryCode);
        }
      });
      if (statesToFetchFor.length > 0) getStates(statesToFetchFor);
      else setLoading(false);
    }
  }, [arrStatesRx.length]);

  useEffect(() => {
    if (scroll !== 0) {
      let box = scrollRef.current;
      if (box) box.scrollTop = scroll;
    }
  }, [scroll]);

  const getStates = (statesToFetchFor) => {
    let statesAvailable = [];
    let statesToBeFetched = [];
    statesToFetchFor.forEach((i) => {
      let Rx = arrStatesRx.find((j) => i === Object.keys(j)[0]);
      if (!Rx) statesToBeFetched.push(i);
      else statesAvailable.push({ code: i, states: Rx[i] });
    });
    if (statesToBeFetched.length === 0) {
      setStates(statesAvailable);
      setLoading(false);
    } else {
      let temp1 = [];
      let statesToDispatch = [];
      statesToBeFetched.forEach(async (cntry, i) => {
        await getBoundary(token, cntry, isAuthMethodOkta)
          .then((res) => {
            if (res.length !== 0) res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
            let temp2 = [];
            res.forEach((item) => temp2.push(item.name));
            statesToDispatch.push({ [cntry]: temp2 });
            temp1.push({ code: cntry, states: temp2 });
            if (i === statesToBeFetched.length - 1) {
              setStates(statesAvailable.concat(temp1));
              dispatch(addStates(statesToDispatch));
              setLoading(false);
            }
          })
          .catch((err) => console.log(err));
      });
    }
  };

  const getStatesForNewRow = async (code) => {
    if (!states.find((st) => st.code === code)) {
      await getBoundary(token, code, isAuthMethodOkta)
        .then((res) => {
          if (res.length !== 0) res.sort((a, b) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0));
          let temp = [];
          res.forEach((item) => temp.push(item.name));
          setStates((prevState) => {
            prevState.push({ code: code, states: temp });
            return [...prevState];
          });
          dispatch(addStates({ [code]: temp }));
          return true;
        })
        .catch((err) => console.log(err));
    }
  };

  const addAnotherHandler = () => {
    const newRow = {
      id: assignIfUniqueID(),
      supplierName: "",
      streetAddress: "",
      country: "",
      city: "",
      state: "",
      postalCode: "",
      tierLevel: "",
      productType: "",
      isDiverseEnterprise: "",
      addedByUser: true,
    };
    dispatch(addSTSupplierData(newRow));
    let box = scrollRef.current;
    if (box !== null && box !== undefined) {
      let scrollTo = box.scrollHeight + 194;
      setScroll(scrollTo);
    }
  };

  const assignIfUniqueID = () => {
    let isUnique = true;
    let random = Math.floor(Math.random() * 10000) + 1;
    let randomID = "NewAdded_" + random;
    for (let i = 0; i < arrTableData.length; i++) {
      if (isNaN(arrTableData[i].id) && arrTableData[i].id.split("_")[1] === random) {
        isUnique = false;
        break;
      }
    }
    if (isUnique) return randomID;
    else assignIfUniqueID();
  };

  const openDeleteModal = (data) => {
    setSupplierIdToBeDeleted(data.id);
    setDeleteSupplierName(data.supplierName);
    setShowDeleteSupplierModal(true);
  };
  const deleteHandler = (id) => {
    dispatch(deleteSTSupplierData(id));
    setScroll(0);
  };

  let boxStyle = props.showActions ? { maxHeight: "580px", overflowY: "scroll", marginBottom: "20px" } : { marginBottom: "20px" };

  if (props.biRef) props.biRef.setLoading = setLoading;
  return (
    <>
      <Card borderRadius="none">
        <CardContent>
          <p>
            <span style={{ fontWeight: 600 }}>Supplier Data</span>
            <span style={{ fontWeight: 200 }}> (View uploaded supplier data here and/or add individual supplier entries)</span>
          </p>
          <br></br>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              {arrTableData.length === 0 ? (
                <Alert variant="info" sx={{ marginBottom: "20px" }}>
                  No data to display.
                </Alert>
              ) : (
                <Box bgcolor="white" style={boxStyle} ref={scrollRef}>
                  {arrTableData.map((i, index) => {
                    return (
                      <SupplierDataCard
                        key={i.id}
                        data={i}
                        index={index}
                        countries={countries}
                        states={states}
                        getStatesForNewRow={getStatesForNewRow}
                        showActions={props.showActions}
                        catalogueData={props.catalogueData}
                        openDeleteModal={openDeleteModal}
                      />
                    );
                  })}
                </Box>
              )}
              {props.showActions && (
                <Grid container justifyContent="flex-end">
                  <Button variant="secondary" onClick={addAnotherHandler}>
                    <AddIcon /> Add Another
                  </Button>
                </Grid>
              )}
            </>
          )}
        </CardContent>
      </Card>
      <ModalGeneric
        showModal={showDeleteSupplierModal}
        setShowModal={setShowDeleteSupplierModal}
        labelBtnPrimary="Delete"
        labelBtnSecondary="Cancel"
        handleSubmit={() => {
          deleteHandler(supplierIdToBeDeleted);
          setShowDeleteSupplierModal(false);
        }}
        msgModal={`${deleteSupplierName ? deleteSupplierName : "This Supplier"} will be deleted. Are you sure you want to continue?`}
        titleModal="Delete confirmation"
      />
    </>
  );
};

export default SupplierData;
